import isObject from 'lodash/isObject';
import { shipmentMethodsMap, ORDER_CONFIRMATION_TYPE } from 'constants/index';
import { mapDataForStoreInfo } from 'utils';
import actionTypes from '../actions/actionTypes';
import { mapAddress } from '../utils';

const INITIAL_STATE = {
  data: null,
  loading: false,
  error: false,
};

const mapItemDetailsPrice = (item) => ({
  itemTaxEach: item.tax || '',
  itemDeliveryPrice: item.freight || '',
  itemOtherPrice: item.other || '',
  itemDutyPrice: item.duty || '',
  orderPrice: item.price || '',
});

export const mapVoidConfirmationData = (confirmationData) => {
  const mappedData = {};

  confirmationData.forEach((item) => {
    const itemData = item?.data;

    if (itemData.voidOrderId) {
      mappedData.voidOrderId = itemData.voidOrderId;
    }

    if (itemData.addressDetails) {
      mappedData.storeAddressInfo = mapDataForStoreInfo(itemData);
    }
  });

  return {
    ...mappedData,
    type: ORDER_CONFIRMATION_TYPE.VOID,
  };
};

const mapOrderShippingDetails = (items) =>
  items.map((item) => shipmentMethodsMap.find((method) => method.id === item.serviceLevelCode));

export const mapItemDetails = (product, item) => {
  if (!product) {
    return isObject(item.price)
      ? item
      : {
          ...item,
          name: item.productName,
          price: mapItemDetailsPrice(item),
        };
  }

  const { giftMessage1, giftMessage2, giftMessage3, giftMessage4, giftMessage5 } = item;
  const giftCard = giftMessage1 || giftMessage2 || giftMessage3 || giftMessage4 || giftMessage5 ? '1' : '0';

  return {
    ...product,
    cmosskuId: product.cmosskuId || item.cmosSkuId || item.cmosskuId,
    name: product.name || item.productName,
    quantity: item.quantity || product.quantity || 0,
    status: item.status || product.status,
    trackingNumber: item.trackingNumber || product.trackingNumber,
    trackingLink: item.trackingLink || product.trackingLink,
    giftOptions: {
      giftCard: giftCard || '0',
      giftWrapCode: item.giftWrapCode || item.giftOptions?.giftWrapCode || product.giftOptions?.giftWrapCode || 'NO',
      giftMessage1: item.giftMessage1 || item.giftOptions?.giftMessage1 || product.giftOptions?.giftMessage1 || '',
      giftMessage2: item.giftMessage2 || item.giftOptions?.giftMessage2 || product.giftOptions?.giftMessage2 || '',
      giftMessage3: item.giftMessage3 || item.giftOptions?.giftMessage3 || product.giftOptions?.giftMessage3 || '',
      giftMessage4: item.giftMessage4 || item.giftOptions?.giftMessage4 || product.giftOptions?.giftMessage4 || '',
      giftMessage5: item.giftMessage5 || item.giftOptions?.giftMessage5 || product.giftOptions?.giftMessage5 || '',
    },
    price: {
      ...product.price,
      ...item.price,
    },
  };
};

export const mapOrderDetails = (order, products = []) => {
  const orderToMap = Array.isArray(order.orderDetails) ? order.orderDetails : [order.orderDetails];
  const orderDetails = orderToMap.map((details) => {
    const items = details.items?.map((item) => {
      const product = products.find((p) => p.cmosskuId === item.cmosSkuId);
      return mapItemDetails(product, item);
    });

    const shipmentMethod = mapOrderShippingDetails(orderToMap[0].items)[0]?.name;
    return {
      ...details,
      shippingAddress: details.shippingAddress && mapAddress(details.shippingAddress),
      shipmentMethod,
      items,
    };
  });

  return {
    ...order,
    orderDetails,
  };
};

const orderDetails = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_ORDER_BY_ID_LOADING:
      return {
        data: null,
        loading: true,
        error: false,
      };

    case actionTypes.GET_ORDER_BY_ID_SUCCESS:
      return {
        data: mapOrderDetails(payload),
        loading: false,
        error: false,
      };

    case actionTypes.GET_ORDER_BY_ID_ERROR:
      return {
        data: null,
        loading: false,
        error: payload,
      };

    case actionTypes.GET_PRODUCTS_FOR_ORDER_LOADING:
    case actionTypes.SEND_GIFT_RECEIPT_LOADING:
    case actionTypes.SUBMIT_VOID_ORDER_LOADING:
      return {
        ...state,
        loading: true,
      };

    case actionTypes.GET_PRODUCTS_FOR_ORDER_SUCCESS:
      return {
        ...state,
        data: mapOrderDetails(state.data, payload),
        loading: false,
      };

    case actionTypes.GET_PRODUCTS_FOR_ORDER_ERROR:
    case actionTypes.SUBMIT_VOID_ORDER_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case actionTypes.RESET_ORDER_DETAILS:
      return { ...INITIAL_STATE };

    case actionTypes.ADD_CACHED_ORDER_DETAILS:
      return {
        data: payload,
        loading: false,
        error: false,
      };

    case actionTypes.SUBMIT_VOID_ORDER_SUCCESS:
      return {
        ...state,
        confirmationData: mapVoidConfirmationData(payload),
        loading: false,
      };

    case actionTypes.SEND_GIFT_RECEIPT_SUCCESS:
      return {
        ...state,
        confirmationData: { ...payload, type: 'gift' },
        loading: false,
      };

    default:
      return state;
  }
};

export default orderDetails;
